import { useChartStore } from '../chart'
const chartStore = useChartStore()

//eslint-disable-next-line
export const commonStore = (axiosInstance, mocks, mockdb, apiUrl, addNotification, parseStatusObject) => {
  return {
    getters: {
      getDeliverySitesLoading(state) {
        return state.deliverySitesLoading
      },
      getActiveDeliverySite(state) {
        if (state.activeDeliverySiteId) {
          return state.deliverySites.find((deliverySite) => deliverySite.id === state.activeDeliverySiteId)
        }
        return state.deliverySites[0]
      },
      getDeliverySites(state) {
        return state.deliverySites
      },
      getNumberOfDeliverySites(state) {
        return state.numberOfDeliverySites
      },
      getPendingRealTimeMeasurementState(state) {
        const currentPendingRequests = (state.pendingRealTimeMeasurementData ?? []).filter((site) => site.id === state.activeDeliverySite.id)
        return currentPendingRequests.length > 0
      }
    },
    actions: {
      modalOpen(context, payload) {
        context.commit('updateModalType', payload)
      },
      modalClose(context) {
        context.commit('updateModalType', null)
      },
      async getCustomerServiceAdminImpersonate(context, payload) {
        const queryParameter = `?customerId=${payload}`
        const requestUrl = `${apiUrl.getCustomerServiceAdminImpersonate}${queryParameter}`

        mocks.mockData(requestUrl, mockdb.randomNumber(1000, 2000), 'getCustomerServiceAdminImpersonate')
        const response = await axiosInstance.get(requestUrl)

        if (response.status === 200) context.commit('updateCustomerServiceAdminImpersonate', response)
        return response
      },
      async postCustomerServiceAdminImpersonate(context, payload) {
        const queryParameter = `?customerId=${payload}`
        const requestUrl = `${apiUrl.postCustomerServiceAdminImpersonate}${queryParameter}`

        mocks.mockPost(requestUrl, payload, mockdb.randomNumber(1000, 2000), 'postCustomerServiceAdminImpersonate')
        const response = await axiosInstance.post(requestUrl)

        return response
      },
      async getCurrentSession(context) {
        if (context.state.currentSession !== null) {
          context.commit('updateModalType', { type: 'session-will-expire', confirmationDispatch: 'extendCurrentSession', ...context.state.currentSession })
        }

        const requestUrl = apiUrl.getCurrentSession

        mocks.mockData(requestUrl, 0, 'getCurrentSession')
        const response = await axiosInstance.get(requestUrl)

        if (response.status !== 200) return

        let responseData = response.data?.data
        let timeLeft = Math.round(Math.max(1, responseData.expires / 60))

        const responseObject = { heading: responseData.heading, message: responseData.message.replace('{timeleft}', timeLeft), buttonText: responseData.buttonText, timeLeft: responseData.expires }

        if (responseData.expires <= 60) {
          sessionStorage.removeItem('vuex')
          window.location.href = '/logoutbyexpiration?corporate=' + context.state.myPagesCorporate
        } else if (responseData.expires <= 360) {
          if (context.state.currentSession === null) context.commit('updateModalType', { type: 'session-will-expire', confirmationDispatch: 'extendCurrentSession' })

          context.commit('updateCurrentSession', responseObject)
        }
      },
      async extendCurrentSession(context) {
        const requestUrl = apiUrl.postExtendCurrentSession

        mocks.mockPost(requestUrl, null, 500, 'postExtendCurrentSession')
        const response = await axiosInstance.post(requestUrl)

        if (response.status === 200) {
          setTimeout(() => {
            context.commit('updateCurrentSession', null)
          }, 500)
        }

        return response
      },
      async fetchDeliverySites(context, { customerId, isPowerTariff }) {
        context.commit('setDeliverySitesLoading', true)
        const response = await axiosInstance.get(context.state.myPagesCorporate && customerId ? `${apiUrl.getDeliverySites}?customerId=${customerId}` : `${apiUrl.getDeliverySites}`)
        let responseData = response.data?.data
        let responseMetaCount = response.data?.meta?.count
        let firstDeliverySiteId = ''
        if ((response.status !== 200 || !responseData || !Array.isArray(responseData)) && !context.state.myPagesCorporate) {
          context.commit('updateGlobalServerError', response.status)
        } else {
          context.commit('updateNumberOfDeliverySites', parseInt(responseMetaCount, 10))

          if (context.state.myPagesCorporate && customerId && responseData.length > 1) {
            if (!isPowerTariff) {
              responseData.unshift({
                id: 'all',
                idFormated: '',
                type: '',
                isConsumptionSite: true,
                address: '',
                measuringMethod: '',
                customerId: customerId,
                customName: ''
              })
            }
          }

          firstDeliverySiteId = responseData[0].id

          const groupsWithDeliverySites = context.state.groups?.filter((item) => (item.deliverySiteIds ?? []).length > 0) ?? []

          if (groupsWithDeliverySites.length > 0) {
            const groupLabel = [{ id: 'group-label' }]
            const deliverySiteLabel = [{ id: 'deliverysite-label' }]
            if (responseData.length > 0 && responseData[0].id === 'all') {
              responseData = responseData.slice(0, 1).concat(groupLabel, groupsWithDeliverySites, deliverySiteLabel, responseData.slice(1))
            } else {
              responseData = groupLabel.concat(groupsWithDeliverySites, deliverySiteLabel, responseData)
            }
          }

          if (context.state.myPagesCorporate && customerId && responseData.length === 0) {
            responseData.push({
              id: 'error',
              idFormated: '',
              type: '',
              isConsumptionSite: true,
              address: '',
              measuringMethod: '',
              customerId: customerId
            })
          }

          context.commit('updateDeliverySites', responseData)

          const paramId = context.state.initiallyChosenDeliverySiteId

          context.commit('updateActiveDeliverySiteId', paramId !== null ? paramId : responseData.length > 0 ? firstDeliverySiteId : {})
          context.commit('setDeliverySitesLoading', false)
        }
      },
      async postTrackAppInsight(context, payload) {
        const payloadObj = {
          message: payload,
          data: {
            applicationName: context.state.myPagesCorporate ? 'energikonto' : 'minasidor'
          }
        }
        const response = await axiosInstance.post(apiUrl.postTrackAppInsight, payloadObj)

        return response
      },
      async fetchConsumptionData(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : `${payload.isFutureOrHistoricalDeliverySite ? '?isfutureorhistoricaldeliverysite=true' : ''}`
        mocks.mockConsumptionData(`${apiUrl.getConsumptionData}${payload.id}${extraParams}`, mockdb.randomNumber(1000, 2000), 'getConsumptionDataMock1', 'getConsumptionDataMock2')

        const response = await axiosInstance.get(`${apiUrl.getConsumptionData}${payload.id}${extraParams}`)
        if (response.status === 200) context.commit('updateConsumptionData', { response: response.data.data, id: payload.id, setActiveDeliverySite: payload.setActiveDeliverySite ?? false })

        return response
      },
      async fetchCompleteConsumptionData(context) {
        for (const site of context.state.deliverySites) {
          let deliverySiteIndex = context.state.deliverySites.findIndex((deliverySite) => deliverySite.id === site.id)

          const requestUrl = `${apiUrl.getConsumptionData}${site.id}`
          mocks.mockConsumptionData(requestUrl, mockdb.randomNumber(100, 200), 'getConsumptionDataMock1', 'getConsumptionDataMock2')

          const response = await axiosInstance.get(requestUrl)
          if (response.status === 200) context.commit('updateCompleteConsumptionData', { response: response.data.data, deliverySiteId: context.state.activeDeliverySiteId, deliverySiteIndex })
        }
      },
      async fetchRealTimeMeasurementData(context, id) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        mocks.mockData(apiUrl.getRealTimeMeasurementData.replace('{id}', id) + extraParams, mockdb.randomNumber(500, 3000), 'getRealTimeMeasurementData')
        const response = await axiosInstance.get(apiUrl.getRealTimeMeasurementData.replace('{id}', id) + extraParams)

        if (response.status === 200) {
          const currentPendingRealTimeMeasurementData = context.state.pendingRealTimeMeasurementData ?? []
          const currentPendingRequestState = (currentPendingRealTimeMeasurementData.find((site) => site.id === id) ?? {}).state
          const newPendingRealTimeMeasurementData = currentPendingRequestState === response.data.data.active ? currentPendingRealTimeMeasurementData.filter((site) => site.id !== id) : currentPendingRealTimeMeasurementData

          context.commit('updateRealTimeMeasurementData', response)
          context.commit('updateRealTimeMeasurementPending', newPendingRealTimeMeasurementData)
        }

        return response
      },
      async postRealTimeMeasurement(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.getRealTimeMeasurementData.replace('{id}', payload.activeDeliverySite)}?realtimeMeasurementsOn=${payload.realtimeMeasurementsOn}${extraParams}`

        mocks.mockPost(requestUrl, null, mockdb.randomNumber(1000, 3000), 'postRealTimeMeasurement')
        const response = await axiosInstance.post(requestUrl)

        const currentPendingRealTimeMeasurementData = context.state.pendingRealTimeMeasurementData ?? []
        const newPendingRealTimeMeasurementData = currentPendingRealTimeMeasurementData.filter((site) => site.id !== payload.activeDeliverySite)
        newPendingRealTimeMeasurementData.push({ id: payload.activeDeliverySite, state: payload.realtimeMeasurementsOn })

        if (response.status === 200) context.commit('updateRealTimeMeasurementPending', newPendingRealTimeMeasurementData)

        addNotification(context, response)

        return response
      },
      async fetchInvoiceData(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const filterParams = payload.filterValue ? `&filter=${payload.filterValue}` : ''
        const requestUrl = `${apiUrl.getInvoiceData.replace('{id}', payload.id)}${payload.params}${extraParams}${filterParams}`

        const response = await axiosInstance.get(requestUrl)

        context.commit('updateInvoiceData', { status: response.status, response: response.data, type: payload, reset: payload.reset })
        return response
      },
      async getTypeAheadCategoriesFaq(_, payload) {
        const response = await axiosInstance.get(`${payload.apiUrl}?query=${payload.query}`)
        return response
      },
      async fetchNewsRoomByFilter(context, payload) {
        const appendFilter = payload.filter.toLowerCase() !== "alla" ? `?filter=${payload.filter}` : '';
        const response = await axiosInstance.get(`${payload.apiUrl}${appendFilter}`);

        return response; 
      },
      SET_activeDeliverySiteId(context, id) {
        context.commit('updateActiveDeliverySiteId', id)
      },
      SET_setConsumptionDataReady(context, readyState) {
        context.commit('setConsumptionDataReady', readyState)
      },
      SET_storeSettings(context, userName) {
        if (context.state.userName === userName) return

        sessionStorage.removeItem('vuex')
        context.commit('setStoreSettings', userName)
      }
    },
    mutations: {
      setDeliverySitesLoading(state, payload) {
        state.deliverySitesLoading = payload
      },
      updateNumberOfDeliverySites(state, payload) {
        state.numberOfDeliverySites = payload
      },
      updateModalType(state, payload) {
        state.modal = payload
      },
      updateCurrentSession(state, payload) {
        state.currentSession = payload
      },
      updateDeliverySites(state, responseData) {
        state.deliverySites = responseData
      },
      updateActiveDeliverySiteId(state, id) {
        const deliverySiteObject = state.deliverySites.find((deliverySite) => deliverySite.id === id) || {}

        state.activeDeliverySiteId = id
        state.activeDeliverySite = deliverySiteObject

        if (deliverySiteObject.consumption) chartStore.$reset({ currentDeliverySite: JSON.parse(JSON.stringify(deliverySiteObject)), currentCustomer: JSON.parse(JSON.stringify(chartStore.currentCustomer)), usePowerTariffPeriod: true })
      },
      updateConsumptionData(state, payload) {
        const deliverySiteIndex = state.deliverySites.findIndex((deliverySite) => deliverySite.id === payload.id)
        const consumption = { ...payload.response }
        const deliverySiteObject = { ...state.deliverySites[deliverySiteIndex], consumption }

        state.deliverySites[deliverySiteIndex] = deliverySiteObject
        chartStore.$reset({
          currentDeliverySite: JSON.parse(JSON.stringify(deliverySiteObject)),
          currentCustomer: JSON.parse(JSON.stringify(chartStore.currentCustomer)),
          pending: true,
        })

        if (payload.setActiveDeliverySite) {
          state.activeDeliverySite = deliverySiteObject
          state.consumptionDataReady = true
        }
      },
      updateCompleteConsumptionData(state, payload) {
        const consumption = { ...payload.response }
        const currentDeliverySite = state.deliverySites[payload.deliverySiteIndex]

        const deliverySiteObject = { ...currentDeliverySite, consumption }

        const newDeliverySites = [...state.deliverySites]
        newDeliverySites[payload.deliverySiteIndex] = deliverySiteObject
        state.deliverySites = newDeliverySites

        if (payload.deliverySiteId && payload.deliverySiteId === deliverySiteObject.id) {
          state.activeDeliverySite = deliverySiteObject
          state.consumptionDataReady = true
        }
      },
      setConsumptionDataReady(state, payload) {
        state.consumptionDataReady = payload
      },
      setStoreSettings(state, userName) {
        state.userName = userName
      },
      updateRealTimeMeasurementPending(state, payload) {
        state.pendingRealTimeMeasurementData = payload
      },
      updateRealTimeMeasurementData(state, payload) {
        state.realTimeMeasurementData = payload.data.data
      },
      updateInvoiceData(state, payload) {
        state.invoiceData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.invoiceData.items, ...(payload.response.data?.items ?? [])]
        }
      },
      updateCustomerServiceAdminImpersonate(state, payload) {
        state.customerServiceAdminImpersonate = payload.data.data
      }
    }
  }
}
